module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#sports",
      toString: function () {
        return this.url;
      }
    }